<div class="salesinvoice-container">
  <div class="salesinvoice-header">
    <h2>{{ salesInvoiceId ? (isEditMode ? 'Edit Sales Invoice' : 'View Sales Invoice') : 'Create New Sales Invoice' }}</h2>
    <div class="header-actions">
      <button *ngIf="salesInvoiceId && !isEditMode" mat-icon-button (click)="downloadPdf()" type="button" matTooltip="Create PDF">
        <mat-icon>picture_as_pdf</mat-icon>
      </button>
      <button *ngIf="salesInvoiceId && !isEditMode" mat-icon-button (click)="downloadPackingSlipPdf()" type="button" matTooltip="Create Packing Slip PDF">
        <mat-icon>local_shipping</mat-icon>
      </button>
      <button *ngIf="salesInvoiceId && !isEditMode" mat-icon-button (click)="downloadLabels()" type="button" matTooltip="Create Labels">
        <mat-icon>description</mat-icon>
      </button>
      <button *ngIf="salesInvoiceId && !isEditMode" mat-raised-button color="accent" (click)="enterEditMode()" type="button">
        <mat-icon>edit</mat-icon> Edit
      </button>
    </div>
  </div>

  <!-- Related Records -->
  <mat-expansion-panel *ngIf="salesOrders.length > 0 || purchaseOrders.length > 0 || proformas.length > 0 || salesInvoiceId" class="related-section" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Related</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="related-subsection">
      <div class="related-subsection-header">
        <h4>Sales Orders</h4>
      </div>
      <table *ngIf="salesOrders.length > 0" mat-table [dataSource]="salesOrders" class="related-table">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>Order #</th>
          <td mat-cell *matCellDef="let so">{{ so.number }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let so">{{ so.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let so">{{ so.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let so">{{ so.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let so">
            <button mat-icon-button color="primary" (click)="viewSalesOrder(so.id); $event.stopPropagation()" type="button" matTooltip="View Sales Order">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="salesOrderColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: salesOrderColumns;" class="clickable-row" (click)="viewSalesOrder(row.id)"></tr>
      </table>
    </div>

    <div *ngIf="purchaseOrders.length > 0" class="related-subsection">
      <div class="related-subsection-header">
        <h4>Purchase Orders</h4>
      </div>
      <table mat-table [dataSource]="purchaseOrders" class="related-table">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>Order #</th>
          <td mat-cell *matCellDef="let po">{{ po.number }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let po">{{ po.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let po">{{ po.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let po">{{ po.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let po">
            <button mat-icon-button color="primary" (click)="viewPurchaseOrder(po.id); $event.stopPropagation()" type="button" matTooltip="View Purchase Order">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="purchaseOrderColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: purchaseOrderColumns;" class="clickable-row" (click)="viewPurchaseOrder(row.id)"></tr>
      </table>
    </div>

    <div *ngIf="proformas.length > 0" class="related-subsection">
      <div class="related-subsection-header">
        <h4>Proformas</h4>
      </div>
      <table mat-table [dataSource]="proformas" class="related-table">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>Proforma #</th>
          <td mat-cell *matCellDef="let pf">{{ pf.number }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let pf">{{ pf.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let pf">{{ pf.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let pf">{{ pf.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let pf">
            <button mat-icon-button color="primary" (click)="viewProforma(pf.id); $event.stopPropagation()" type="button" matTooltip="View Proforma">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="proformaColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: proformaColumns;" class="clickable-row" (click)="viewProforma(row.id)"></tr>
      </table>
    </div>
  </mat-expansion-panel>

  <form [formGroup]="salesInvoiceForm" (ngSubmit)="onSubmit()" class="salesinvoice-form" [class.view-mode]="!isEditMode">
    <!-- Invoice Information Section -->
    <h3>Invoice Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Invoice Number</mat-label>
        <input matInput formControlName="invoiceNumber" placeholder="Enter invoice number" [readonly]="!isEditMode">
        <mat-error *ngIf="salesInvoiceForm.get('invoiceNumber')?.hasError('required')">
          Invoice number is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Invoice Date</mat-label>
        <input matInput [matDatepicker]="invoiceDatePicker" formControlName="invoiceDate" [readonly]="!isEditMode">
        <mat-datepicker-toggle matSuffix [for]="invoiceDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
        <mat-datepicker #invoiceDatePicker></mat-datepicker>
        <mat-error *ngIf="salesInvoiceForm.get('invoiceDate')?.hasError('required')">
          Invoice date is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Due Date</mat-label>
        <input matInput [matDatepicker]="dueDatePicker" formControlName="dueDate" [readonly]="!isEditMode">
        <mat-datepicker-toggle matSuffix [for]="dueDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
        <mat-datepicker #dueDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status" [disabled]="!isEditMode">
          <mat-option *ngFor="let status of orderStatuses" [value]="status.name">{{ status.description }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship Date</mat-label>
        <input matInput [matDatepicker]="shipDatePicker" formControlName="shipDate" [readonly]="!isEditMode">
        <mat-datepicker-toggle matSuffix [for]="shipDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
        <mat-datepicker #shipDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Shipper</mat-label>
        <input matInput formControlName="shipper" placeholder="Enter shipper name" [readonly]="!isEditMode">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Sales Person</mat-label>
        <input matInput formControlName="salesPerson" placeholder="Sales person name" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field" style="display: none;">
        <mat-label>QuickBooks ID</mat-label>
        <input matInput type="number" formControlName="qboId" placeholder="Enter QuickBooks ID">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field" style="display: none;">
        <mat-label>Sales Order ID (Optional)</mat-label>
        <input matInput type="number" formControlName="salesOrderId" placeholder="Related sales order">
      </mat-form-field>
    </div>

    <!-- Customer Information Section -->
    <h3>Customer Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Customer</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput 
               formControlName="customerSearch" 
               placeholder="Search customer by name or ID"
               [readonly]="!isEditMode"
               [matAutocomplete]="autoCustomer">
        <button mat-icon-button matSuffix 
                *ngIf="salesInvoiceForm.get('customerSearch')?.value && isEditMode"
                (click)="clearCustomer(); $event.stopPropagation()"
                type="button"
                matTooltip="Clear customer">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #autoCustomer="matAutocomplete" 
                          [displayWith]="displayCustomer.bind(this)"
                          (optionSelected)="onCustomerSelected($event.option.value)">
          <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
            {{ customer.name || customer.Name }} (ID: {{ customer.id || customer.Id }})
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="salesInvoiceForm.get('customerId')?.hasError('required')">
          Customer is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Customer PO</mat-label>
        <input matInput formControlName="customerPO" placeholder="Enter customer PO" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Shipping Address</mat-label>
        <mat-select formControlName="shippingAddressId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let address of customerAddresses" [value]="address.id || address.Id">
            {{ formatAddress(address) }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="salesInvoiceForm.get('shippingAddressId')?.value"
          [matTooltip]="getAddressTooltip(salesInvoiceForm.get('shippingAddressId')?.value, customerAddresses)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Billing Address</mat-label>
        <mat-select formControlName="billingAddressId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let address of customerAddresses" [value]="address.id || address.Id">
            {{ formatAddress(address) }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="salesInvoiceForm.get('billingAddressId')?.value"
          [matTooltip]="getAddressTooltip(salesInvoiceForm.get('billingAddressId')?.value, customerAddresses)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Customer Contact</mat-label>
        <mat-select formControlName="customerContactId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let contact of customerContacts" [value]="contact.id || contact.Id">
            {{ contact.firstName || contact.FirstName }} {{ contact.lastName || contact.LastName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship Attention To</mat-label>
        <input matInput formControlName="shipAttentionTo" placeholder="Attention to" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <!-- Products Section -->
    <div class="section-header">
      <h3>Products</h3>
      <button mat-mini-fab color="primary" type="button" (click)="addProduct()" matTooltip="Add Product" *ngIf="isEditMode">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <mat-accordion formArrayName="products">
      <mat-expansion-panel *ngFor="let product of products.controls; let i = index" [formGroupName]="i">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ getProductTitle(i) }}
          </mat-panel-title>
          <mat-panel-description>
            <button mat-icon-button color="warn" type="button" (click)="removeProduct(i); $event.stopPropagation()" matTooltip="Remove Product" *ngIf="isEditMode">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-panel-description>
        </mat-expansion-panel-header>
        
        <div class="form-row">
          <input type="hidden" formControlName="lotNumId">
          <input type="hidden" formControlName="productId">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Lot Number</mat-label>
            <mat-icon matPrefix>qr_code</mat-icon>
            <input matInput
                   formControlName="lotNumSearch"
                   placeholder="Search by lot #, catalog #, or product name"
                   [readonly]="!isEditMode"
                   [matAutocomplete]="autoLotNum">
            <button mat-icon-button matSuffix
                    *ngIf="product.get('lotNumSearch')?.value && isEditMode"
                    (click)="clearLotNum(i); $event.stopPropagation()"
                    type="button"
                    matTooltip="Clear lot number">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoLotNum="matAutocomplete"
                              [displayWith]="displayLotNum.bind(this)"
                              (optionSelected)="onLotNumSelected(i, $event.option.value)">
              <mat-option *ngFor="let ln of filteredLotNumsList[i] | async" [value]="ln">
                <span class="lot-num-option-num">{{ ln.number || ln.Number }}</span>
                <span class="lot-num-option-hint">
                  &mdash; {{ ln.vendorProduct?.product?.name || ln.vendorProduct?.product?.Name || ln.product?.name || ln.product?.Name || '' }}
                  <span *ngIf="ln.vendorProduct?.product?.catalogNum || ln.vendorProduct?.product?.CatalogNum || ln.product?.catalogNum || ln.product?.CatalogNum">
                    [{{ ln.vendorProduct?.product?.catalogNum || ln.vendorProduct?.product?.CatalogNum || ln.product?.catalogNum || ln.product?.CatalogNum }}]
                  </span>
                  <span *ngIf="ln.vendorProduct?.vendor?.name || ln.vendorProduct?.vendor?.Name">
                    &mdash; {{ ln.vendorProduct?.vendor?.name || ln.vendorProduct?.vendor?.Name }}
                  </span>
                </span>
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="product.get('lotNumId')?.hasError('required')">
              Lot Number is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Catalog #</mat-label>
            <input matInput formControlName="catalogNum" placeholder="Auto-filled from lot number" readonly>
          </mat-form-field>
          
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Unit Price</mat-label>
            <input matInput type="number" formControlName="unitPrice" placeholder="0.00" step="0.01" [readonly]="!isEditMode">
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="product.get('unitPrice')?.hasError('required')">
              Unit price is required
            </mat-error>
            <mat-error *ngIf="product.get('unitPrice')?.hasError('min')">
              Price must be positive
            </mat-error>
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" class="form-field">
            <input matInput type="number" formControlName="quantityAvailable" placeholder="Qty Available" readonly>
            <mat-hint>Available</mat-hint>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Quantity</mat-label>
            <input matInput type="number" formControlName="quantity" placeholder="1" step="0.01" [readonly]="!isEditMode">
            <mat-hint *ngIf="isEditMode && product.get('quantityOnHand')?.value !== null" [class.quantity-hint-exceeded]="isQuantityExceeded(i)">
              On Hand: {{ product.get('quantityOnHand')?.value }}
            </mat-hint>
            <mat-error *ngIf="product.get('quantity')?.hasError('required')">
              Quantity is required
            </mat-error>
            <mat-error *ngIf="product.get('quantity')?.hasError('min')">
              Quantity must be greater than 0
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Unit Type</mat-label>
            <mat-select formControlName="unitType" [disabled]="!isEditMode">
              <mat-option *ngFor="let type of unitTypes" [value]="type">{{ type | titlecase }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-row" style="display: none;">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Discount %</mat-label>
            <input matInput type="number" formControlName="discountPercent" placeholder="0" step="0.01">
            <span matSuffix>%</span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Discount Amount</mat-label>
            <input matInput type="number" formControlName="discountAmount" placeholder="0.00" step="0.01">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>

        <!-- <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Tax Rate %</mat-label>
            <input matInput type="number" formControlName="taxRate" placeholder="0" step="0.01">
            <span matSuffix>%</span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Tax Amount</mat-label>
            <input matInput type="number" formControlName="taxAmount" placeholder="0.00" step="0.01">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div> -->

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field" style="display: none;">
            <mat-label>Tax Code</mat-label>
            <input matInput formControlName="taxCode" placeholder="Tax classification code">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field" style="display: none;">
            <mat-label>Line Number</mat-label>
            <input matInput type="number" formControlName="lineNumber" readonly>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description" placeholder="Line item description" [readonly]="!isEditMode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Desired Packaging</mat-label>
            <input matInput formControlName="desiredPackaging" [readonly]="!isEditMode">
          </mat-form-field>
        </div>

        <!-- <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes" rows="2" placeholder="Line item notes" [readonly]="!isEditMode"></textarea>
          </mat-form-field>
        </div> -->
      </mat-expansion-panel>

      <div *ngIf="products.length === 0" class="empty-message">
        No products added. Click + to add a product line.
      </div>
    </mat-accordion>

    <!-- Financial Information Section -->
    <h3>Financial Information</h3>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Shipping Amount</mat-label>
        <input matInput type="number" formControlName="shippingAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesInvoiceForm.get('shippingAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Handling Fee</mat-label>
        <input matInput type="number" formControlName="handlingFee" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesInvoiceForm.get('handlingFee')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Invoice Discount Amount</mat-label>
        <input matInput type="number" formControlName="discountAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesInvoiceForm.get('discountAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Invoice Tax Amount</mat-label>
        <input matInput type="number" formControlName="taxAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesInvoiceForm.get('taxAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Amount Paid</mat-label>
        <input matInput type="number" formControlName="amountPaid" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="salesInvoiceForm.get('amountPaid')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Payment Information Section -->
    <h3>Payment Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Payment Terms</mat-label>
        <mat-select formControlName="paymentTerms" [disabled]="!isEditMode">
          <mat-option value="">None</mat-option>
          <mat-option *ngFor="let term of paymentTermsList" [value]="term.name">{{ term.description }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Payment Method</mat-label>
        <mat-select formControlName="paymentMethod" [disabled]="!isEditMode">
          <mat-option value="">None</mat-option>
          <mat-option value="Credit Card">Credit Card</mat-option>
          <mat-option value="Check">Check</mat-option>
          <mat-option value="Wire Transfer">Wire Transfer</mat-option>
          <mat-option value="ACH">ACH</mat-option>
          <mat-option value="Cash">Cash</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Additional Notes to Customer</mat-label>
        <textarea matInput formControlName="notes" rows="3" placeholder="Additional Notes to Customer" [readonly]="!isEditMode"></textarea>
      </mat-form-field>
    </div>

    <!-- Bank Details Section -->
    <mat-expansion-panel formGroupName="bankDetails" class="bankdetails-section">
      <mat-expansion-panel-header>
        <mat-panel-title>Bank Details</mat-panel-title>
      </mat-expansion-panel-header>
      
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Account Name</mat-label>
          <input matInput formControlName="accountName" placeholder="Enter account name" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Bank Name</mat-label>
          <input matInput formControlName="bankName" placeholder="Enter bank name" readonly>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Account Number</mat-label>
          <input matInput formControlName="accountNumber" placeholder="Enter account number" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Routing Number</mat-label>
          <input matInput formControlName="routingNumber" placeholder="Enter routing number" readonly>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>SWIFT Code</mat-label>
          <input matInput formControlName="swiftCode" placeholder="Enter SWIFT code" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Fedwire ABA</mat-label>
          <input matInput formControlName="fedwireABA" placeholder="Enter Fedwire ABA" readonly>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>IBAN Code</mat-label>
          <input matInput formControlName="ibanCode" placeholder="Enter IBAN code" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Bank Address</mat-label>
          <input matInput formControlName="bankAddress" placeholder="Enter bank address" readonly>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field-full">
          <mat-label>Notes</mat-label>
          <textarea matInput formControlName="notes" rows="2" placeholder="Additional Notes" readonly></textarea>
        </mat-form-field>
      </div>

      <div class="form-row" style="display: none;">
        <mat-checkbox formControlName="isActive">Active</mat-checkbox>
      </div>
    </mat-expansion-panel>

    <!-- Remit To Address Section -->
    <mat-expansion-panel formGroupName="remitToAddress" class="remit-section">
      <mat-expansion-panel-header>
        <mat-panel-title>Remit To Address</mat-panel-title>
      </mat-expansion-panel-header>
      
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field-full">
          <mat-label>Address Line 1</mat-label>
          <input matInput formControlName="addressLine1" placeholder="Enter street address" readonly>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field-full">
          <mat-label>Address Line 2</mat-label>
          <input matInput formControlName="addressLine2" placeholder="Apartment, suite, etc. (optional)" readonly>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" placeholder="Enter city" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>State</mat-label>
          <input matInput formControlName="state" placeholder="Enter state" readonly>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Zip Code</mat-label>
          <input matInput formControlName="postalCode" placeholder="Enter zip code" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country" placeholder="Enter country" readonly>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <!-- Invoice Total Section -->
    <div *ngIf="products.length > 0" class="total-section">
      <div class="total-row">
        <span class="total-label">Subtotal:</span>
        <span class="total-amount">{{ calculateSubTotal() | currency }}</span>
      </div>
      <div class="total-row">
        <span class="total-label">Discount:</span>
        <span class="total-amount discount">-{{ salesInvoiceForm.get('discountAmount')?.value | currency }}</span>
      </div>
      <div class="total-row">
        <span class="total-label">Tax:</span>
        <span class="total-amount">{{ salesInvoiceForm.get('taxAmount')?.value | currency }}</span>
      </div>
      <div class="total-row">
        <span class="total-label">Shipping:</span>
        <span class="total-amount">{{ salesInvoiceForm.get('shippingAmount')?.value | currency }}</span>
      </div>
      <div class="total-row">
        <span class="total-label">Handling Fee:</span>
        <span class="total-amount">{{ salesInvoiceForm.get('handlingFee')?.value | currency }}</span>
      </div>
      <div class="total-row total-highlight">
        <span class="total-label">Total Amount:</span>
        <span class="total-amount">{{ calculateTotal() | currency }}</span>
      </div>
      <div class="total-row">
        <span class="total-label">Amount Paid:</span>
        <span class="total-amount paid">-{{ salesInvoiceForm.get('amountPaid')?.value | currency }}</span>
      </div>
      <div class="total-row balance-highlight">
        <span class="total-label">Balance Due:</span>
        <span class="total-amount">{{ calculateBalance() | currency }}</span>
      </div>
    </div>

    <div class="form-actions" *ngIf="isEditMode">
      <button mat-raised-button color="primary" type="submit" [disabled]="!salesInvoiceForm.valid">
        Save
      </button>
      <button mat-raised-button type="button" (click)="onCancel()">
        Cancel
      </button>
    </div>
  </form>

  <p *ngIf="errorMessage" class="error-message">
    <mat-icon>error_outline</mat-icon>
    {{ errorMessage }}
  </p>
</div>
